// store/modules/events.js

import { apiDataService } from "@/services/apiDataService";

export default {
	namespaced: true,
	state: {
		events: [],
		error: null,
		loading: false,
	},
	mutations: {
		SET_EVENTS(state, events) {
			state.events = events;
		},
		SET_ERROR(state, error) {
			state.error = error;
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
		},
		UPDATE_EVENT(state, updatedEvent) {
			const index = state.events.findIndex(
				(e) => e.event_id === updatedEvent.event_id
			);
			if (index !== -1) {
				state.events.splice(index, 1, updatedEvent);
			} else {
				state.events.push(updatedEvent);
			}
		},
		REMOVE_EVENT(state, eventId) {
			state.events = state.events.filter((e) => e.event_id !== eventId);
		},
	},
	actions: {
		async fetchAllEvents({ commit }) {
			commit("SET_LOADING", true);
			commit("SET_ERROR", null); // clear previous error
			try {
				const events = await apiDataService.getEvents();
				commit("SET_EVENTS", events.data);
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to fetch events");
			} finally {
				commit("SET_LOADING", false);
			}
		},
		async updateEvent({ commit }, formData) {
			commit("SET_LOADING", true);
			commit("SET_ERROR", null);
			try {
				const response = await apiDataService.updateEvent(formData);
				commit("UPDATE_EVENT", response.data);
				return response;
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to update event");
				throw error;
			} finally {
				commit("SET_LOADING", false);
			}
		},
		async deleteEvent({ commit }, eventId) {
			commit("SET_LOADING", true);
			commit("SET_ERROR", null);
			try {
				const response = await apiDataService.deleteEvent(eventId);
				commit("REMOVE_EVENT", eventId);
				return response;
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to delete event");
				throw error;
			} finally {
				commit("SET_LOADING", false);
			}
		},
		async fetchEventById({ commit, getters }, { eventId, force = false }) {
			if (!force) {
				const cached = getters.getEventById(eventId);
				if (cached) return cached;
			}

			commit("SET_LOADING", true);
			commit("SET_ERROR", null);
			try {
				const event = await apiDataService.getEvent(eventId);
				commit("UPDATE_EVENT", event.data);
				return event.data;
			} catch (error) {
				commit("SET_ERROR", error.message || "Failed to fetch event");
				throw error;
			} finally {
				commit("SET_LOADING", false);
			}
		},
	},
	getters: {
		allEvents: (state) => state.events,
		fetchError: (state) => state.error,
		isLoading: (state) => state.loading,
		getEventById: (state) => (id) => {
			return (
				state.events.find((event) => String(event.event_id) === String(id)) ||
				null
			);
		},
	},
};
